// Plan name mappings and utilities

export const PLAN_DISPLAY_NAMES: Record<string, string> = {
  free: 'Free Edition',
  standard: 'Standard Edition',
  starter: 'Standard Edition', // Legacy support - map old 'starter' to 'Standard Edition'
  pro: 'Professional Edition',
  professional: 'Professional Edition', // Handle both 'pro' and 'professional'
  enterprise: 'Enterprise Edition',
};

export const PLAN_SHORT_NAMES: Record<string, string> = {
  free: 'Free',
  standard: 'Standard',
  starter: 'Standard', // Legacy support - map old 'starter' to 'Standard'
  pro: 'Professional',
  professional: 'Professional',
  enterprise: 'Enterprise',
};

// Get the display name for a plan
export function getPlanDisplayName(plan: string | null | undefined): string {
  if (!plan) return 'Free Edition';
  return PLAN_DISPLAY_NAMES[plan.toLowerCase()] || `${plan} Plan`;
}

// Get the short name for a plan (for badges, etc.)
export function getPlanShortName(plan: string | null | undefined): string {
  if (!plan) return 'Free';
  return PLAN_SHORT_NAMES[plan.toLowerCase()] || plan;
}

// Get plan badge color classes
export function getPlanBadgeColor(plan: string | null | undefined): string {
  const planKey = plan?.toLowerCase() || 'free';
  
  switch (planKey) {
    case 'free':
      return 'bg-gray-100 text-gray-800';
    case 'starter':
      return 'bg-green-100 text-green-800';
    case 'pro':
    case 'professional':
      return 'bg-blue-100 text-blue-800';
    case 'enterprise':
      return 'bg-purple-100 text-purple-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

// Get plan features for display
export function getPlanLimits(plan: string | null | undefined): { maxUsers: number | null; displayUsers: string } {
  // All plans now have unlimited users
  return { maxUsers: null, displayUsers: 'Unlimited users' };
}